// tgrm-variant-price-fix.js
// Ensures the displayed price updates correctly when a product variant is selected.
// Compatible with Shopify 2.0 themes (Dawn, Gecko/T4S, etc.)

(function() {
  'use strict';

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = (parseInt(cents, 10) / 100).toFixed(2);
    return '$' + value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function updatePrice(variant) {
    if (!variant) return;

    // Update all price elements on the page
    var priceContainers = document.querySelectorAll(
      '[data-product-price], .t4s-price, .price__current, .price-item--regular, .price-item--sale'
    );

    priceContainers.forEach(function(el) {
      var container = el.closest('.t4s-product-price, .price, [data-product-price]');
      if (!container) return;

      // Only update if this is a single-product context (not a grid card)
      if (container.closest('.t4s-product-item:not(.t4s-product-single)')) return;

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        // On sale
        el.innerHTML = '<ins>' + formatMoney(variant.price) + '</ins> <del>' + formatMoney(variant.compare_at_price) + '</del>';
      } else {
        el.innerHTML = formatMoney(variant.price);
      }
    });

    // Also handle the structured price display used by T4S/Gecko themes
    var ins = document.querySelectorAll('[data-product-price] ins, .t4s-product__price ins');
    var del = document.querySelectorAll('[data-product-price] del, .t4s-product__price del');
    if (ins.length || del.length) {
      ins.forEach(function(el) { el.textContent = formatMoney(variant.price); });
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        del.forEach(function(el) { el.textContent = formatMoney(variant.compare_at_price); el.style.display = ''; });
      } else {
        del.forEach(function(el) { el.style.display = 'none'; });
      }
    }
  }

  // Listen for Shopify variant:changed event (fired by theme selectors)
  document.addEventListener('variant:changed', function(evt) {
    if (evt.detail && evt.detail.variant) {
      updatePrice(evt.detail.variant);
    } else if (evt.currentVariant) {
      updatePrice(evt.currentVariant);
    }
  });

  // Also listen for jQuery-style variant:changed (used by T4S theme)
  if (window.jQuery_T4NT) {
    jQuery_T4NT(document).on('variant:changed', function(evt) {
      var v = evt.currentVariant || (evt.detail && evt.detail.variant);
      if (v) updatePrice(v);
    });
  }

  // Fallback: watch the hidden select[name="id"] for changes
  function watchVariantSelect() {
    var selects = document.querySelectorAll('select[name="id"], select[name="items[][id]"]');
    selects.forEach(function(select) {
      if (select._tgrmWatched) return;
      select._tgrmWatched = true;
      select.addEventListener('change', function() {
        var variantId = parseInt(this.value, 10);
        var productData = null;
        try {
          var jsonEl = document.querySelector('.pr_variants_json');
          if (jsonEl) productData = JSON.parse(jsonEl.textContent);
        } catch(e) {}
        if (productData) {
          var variant = productData.find(function(v) { return v.id === variantId; });
          if (variant) updatePrice(variant);
        } else {
          // Fetch from product JSON
          var handle = document.querySelector('[data-product-handle]');
          if (!handle) return;
          fetch('/products/' + handle.dataset.productHandle + '.js')
            .then(function(r) { return r.json(); })
            .then(function(p) {
              var variant = (p.variants || []).find(function(v) { return v.id === variantId; });
              if (variant) updatePrice(variant);
            })
            .catch(function() {});
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', watchVariantSelect);
  setTimeout(watchVariantSelect, 1000);

})();


// TGRM: on carts that carry the in-store bulk-price discount, remove the saved-amount framing:
// the line-item "(-$xxx.xx)" and the subtotal original/savings figures. The struck per-unit price
// on each line still shows the bulk saving; only the aggregate "$xxx off" figure is removed.
// A class on <html> drives CSS so the rule survives the mini-cart's async re-renders.
(function() {
  try {
    var st = document.createElement('style');
    st.textContent = '.tgrm-hide-cart-savings .t4s-cart__originalPrice,.tgrm-hide-cart-savings .t4s-cart__discountPrice{display:none!important;}';
    (document.head || document.documentElement).appendChild(st);
  } catch (e) {}
  function tgrmCleanBulkDiscount() {
    var els = document.querySelectorAll('li.t4s-order-discount__item');
    var foundBulk = false;
    for (var i = 0; i < els.length; i++) {
      var li = els[i];
      if ((li.textContent || '').toLowerCase().indexOf('bulk') === -1) continue;
      foundBulk = true;
      if (li.getAttribute('data-tgrm-clean')) continue;
      var nodes = li.childNodes;
      for (var j = 0; j < nodes.length; j++) {
        if (nodes[j].nodeType === 3 && /\(-[^)]*\)\s*$/.test(nodes[j].textContent)) {
          nodes[j].textContent = nodes[j].textContent.replace(/\s*\(-[^)]*\)\s*$/, '');
        }
      }
      li.setAttribute('data-tgrm-clean', '1');
    }
    if (foundBulk) { document.documentElement.classList.add('tgrm-hide-cart-savings'); }
  }
  tgrmCleanBulkDiscount();
  document.addEventListener('DOMContentLoaded', tgrmCleanBulkDiscount);
  setTimeout(tgrmCleanBulkDiscount, 400);
  setTimeout(tgrmCleanBulkDiscount, 1200);
  try { new MutationObserver(tgrmCleanBulkDiscount).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
})();
